export default {
  create: {
    title: 'Add',
    subtitle: 'Numerex',
  },
  edit: {
    title: 'Edit',
    subtitle: 'Numerex',
    button: {
      add: 'New game',
    },
  },
  list: {
    title: 'Numerex',
    subtitle: 'List',
    add: 'New game',
  },
  card: {
    title: 'Numerex',
    actions: 'Actions',
  },
  table: {
    title: 'Active games',
    searchPlaceholder: 'Search...',
  },
  form: {
    name: {
      label: 'Name:',
      placeholder: 'E.g.: Numerex Level 1',
      invalid: 'Name is required',
    },
    rows: {
      label: 'Rows:',
    },
    columns: {
      label: 'Columns:',
    },
    level: {
      label: 'Level:',
      placeholder: 'Select the level...',
    },
    generationMode: {
      label: 'Generation mode:',
      placeholder: 'Select the mode...',
      options: {
        simple: 'Simple',
        distribution: 'Distribution',
      },
    },
    numberLengthRange: {
      section: 'Distribution',
      min: {
        label: 'Minimum length',
        tooltip: 'Minimum length of generated numbers.',
      },
      max: {
        label: 'Maximum length',
        tooltip: 'Maximum length of generated numbers.',
      },
    },
    prioritizeQuality: {
      label: 'Prioritize quality',
      tooltip:
        'Runs extra attempts after the main generation to try to improve the result. May take longer.',
    },
    numbersList: {
      label: 'Number list:',
      copyTooltip: 'Copy list to clipboard',
    },
    grid: {
      cellLabel: 'Cell row {row}, column {col}',
    },
  },
  sidebar: {
    exportHint: 'You need to save before exporting.',
    defaultFileName: 'numerex',
  },
  button: {
    generate: 'Generate game',
  },
  alert: {
    gameSaved: 'Game saved successfully!',
    cleared: 'Grid cleared successfully!',
    generated: 'Numerex generated successfully!',
    generateFailed: 'Could not generate the Numerex.',
    numberLengthRangeInvalid:
      'Enter a valid number length range (min ≤ max).',
    numbersListCopied: 'Number list copied!',
    numbersListCopyFailed: 'Could not copy the number list.',
    sendSuccess: 'Sent successfully',
    sendError: 'Error sending. Please try again.',
  },
};
